export default __webpack_public_path__ + "static/media/team40.e23052bb.JPG";